module.exports = __webpack_public_path__ + "img/coin_gold_copacked.73042167.png";